export default __webpack_public_path__ + "static/PEAC-a2db7028374739543ca5d744bae6885f.png";